export const PROOF_ENFORCEMENT_MODES = Object.freeze({
  NONE: "none",
  AT_LEAST_ONE: "at_least_one",
  ALL_REQUIRED_CHARGES: "all_required_charges",
});

export const PROOF_ENFORCEMENT_OPTIONS = Object.freeze([
  {
    value: PROOF_ENFORCEMENT_MODES.NONE,
    label: "No proof check before generation",
    description: "Purchase Orders can be generated regardless of proof status.",
  },
  {
    value: PROOF_ENFORCEMENT_MODES.AT_LEAST_ONE,
    label: "Enforce at least one proof on order",
    description: "At least one qualifying proof must exist for the order before Purchase Orders can be generated.",
  },
  {
    value: PROOF_ENFORCEMENT_MODES.ALL_REQUIRED_CHARGES,
    label: "Every charge that requires proof must be set",
    description: "Every Decoration Network charge configured as requiring proof must have its proof requirement satisfied before its Purchase Order can be generated.",
  },
]);

const VALID_PROOF_ENFORCEMENT_MODES = Object.freeze(
  Object.values(PROOF_ENFORCEMENT_MODES)
);

export const normalizeProofEnforcementMode = (value) =>
  VALID_PROOF_ENFORCEMENT_MODES.includes(value)
    ? value
    : PROOF_ENFORCEMENT_MODES.NONE;
